import { render } from "./AtsiriMuseumScheduler.vue?vue&type=template&id=63b39f3a&scoped=true"
import script from "./AtsiriMuseumScheduler.vue?vue&type=script&lang=js"
export * from "./AtsiriMuseumScheduler.vue?vue&type=script&lang=js"

import "./AtsiriMuseumScheduler.vue?vue&type=style&index=0&id=63b39f3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenz\\atsiriBookingApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b39f3a"]])

export default __exports__